export const videoUrl = 'http://upload.artronartdata.com'
